import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import VivahLogo from '../components/VivahLogo';

const STEPS = [
  {
    step: '1',
    icon: '📝',
    title: 'Register Marriage Profile',
    desc: 'Fill out comprehensive marriage details including Birth Date, Birth Time, Birth Place, and Gotra for authentic Kundali evaluation.'
  },
  {
    step: '2',
    icon: '📲',
    title: 'Pay Registration Fee (NPR 1,000)',
    desc: 'Pay NPR 1,000 registration fee via eSewa or Fonepay QR code to 9857074103 (Laxmikant Timilsina) and send receipt screenshot to 9857074103.'
  },
  {
    step: '3',
    icon: '🤝',
    title: 'Personalized Match Assignment (3 Matches)',
    desc: 'Renowned marriage consultant Laxmikant Timilsina personally evaluates profiles and assigns 3 confidential, curated matches.'
  },
  {
    step: '4',
    icon: '🎉',
    title: 'Wedding Feast & Event Decor',
    desc: 'When couples decide to marry, Sabitri Catering & Tent House (Krishna Khanal - 9867155395) manages your wedding feast & mandap decor.'
  }
];

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        {/* Unified Wedding Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <div style={{ marginBottom: '1.2rem' }}>
              <span className="badge" style={{ background: 'rgba(247, 208, 112, 0.25)', color: '#F7D070', border: '1px solid rgba(247, 208, 112, 0.4)' }}>
                ✦ NEPAL'S TRUSTED MARRIAGE CONSULTATION AGENCY ✦
              </span>
            </div>

            <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center' }}>
              <VivahLogo size="large" />
            </div>

            <h1 className="hero-title">
              Traditional Marriage Consultation & Authentic Matchmaking in Nepal
            </h1>

            <p className="hero-subtitle">
              Expertly managed by renowned marriage consultant <strong>Laxmikant Timilsina</strong>. Business Location: <strong>Yogikuti, Butwal</strong> | Contact & QR Payment: <strong>9857074103</strong>. Registration Fee: <strong>NPR 1,000</strong> with <strong>3 Curated Matches</strong>.
            </p>

            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn btn-secondary" onClick={() => navigate('/consultation/register')}>
                Register Profile (NPR 1,000) →
              </button>
              <button className="btn btn-tertiary" onClick={() => navigate('/consultation/payment')}>
                📲 QR Payment to Laxmikant (9857074103)
              </button>
            </div>
          </div>
        </section>

        {/* Marriage Consultation Stat Box Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1.5rem',
          marginBottom: '4rem'
        }}>
          <div className="stat-box">
            <div className="stat-number">1,500+</div>
            <div className="stat-label">Registered Nepalese Families</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">3</div>
            <div className="stat-label">Curated Matches Per Profile</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">100%</div>
            <div className="stat-label">Confidential & Verified</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">NPR 1,000</div>
            <div className="stat-label">One-Time Registration Fee</div>
          </div>
        </div>

        {/* 4 Steps Registration Workflow */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 className="section-title">How Marriage Consultation Works</h2>
          <p style={{ textAlign: 'center', color: '#6E615E', marginBottom: '3rem' }}>
            A serious marriage consultation platform — not a dating website.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))',
          gap: '1.8rem',
          marginBottom: '4rem'
        }}>
          {STEPS.map((s) => (
            <div key={s.step} className="card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <span style={{ fontSize: '2.5rem' }}>{s.icon}</span>
                  <span className="badge-light">Step {s.step}</span>
                </div>
                <h3 style={{ fontSize: '1.35rem', fontWeight: 800, color: '#9E1B32', marginBottom: '0.5rem', fontFamily: 'var(--serif)' }}>
                  {s.title}
                </h3>
                <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.6 }}>
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Match Limit & Confidentiality Policy Card */}
        <div className="card" style={{
          background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)',
          color: 'white',
          border: '1.5px solid #D4AF37',
          marginBottom: '4rem',
          textAlign: 'center'
        }}>
          <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.8rem' }}>
            🔒 Fee (NPR 1,000) & 3 Matches Policy
          </span>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.2rem', fontWeight: 700, color: '#F7D070', margin: '0.5rem 0' }}>
            Personal Matchmaking by Laxmikant Timilsina
          </h2>
          <p style={{ fontSize: '0.92rem', color: 'rgba(255,255,255,0.88)', maxWidth: '780px', margin: '0 auto 1.6rem', lineHeight: 1.7 }}>
            Upon paying the <strong>NPR 1,000 registration fee</strong> and completing profile submission, users are assigned <strong>3 confidential, curated match recommendations</strong>. All phone numbers and personal identities remain protected until mutually accepted. Additional match recommendations require extra consultation fees.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-secondary" onClick={() => navigate('/consultation/register')}>
              Register Profile (NPR 1,000) →
            </button>
            <button className="btn btn-tertiary" onClick={() => navigate('/consultation/payment')}>
              📲 QR Payment to Laxmikant (9857074103)
            </button>
          </div>
        </div>

        {/* Sabitri Catering & Tent House Integration Card */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 className="section-title">Wedding Feast & Event Services Partner</h2>
          <p style={{ textAlign: 'center', color: '#6E615E', marginBottom: '3rem' }}>
            When couples decide to marry, Sabitri Catering & Tent House handles your wedding celebration.
          </p>
        </div>

        <div className="card" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', alignItems: 'center', marginBottom: '4rem' }}>
          <div>
            <span className="badge-light">🍽️ Wedding Catering & Decor Partner</span>
            <h3 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#9E1B32', margin: '0.6rem 0 0.3rem', fontFamily: 'var(--serif)' }}>
              Sabitri Catering and Tent House
            </h3>
            <div style={{ fontSize: '0.88rem', fontWeight: 700, color: '#8C6A23', marginBottom: '0.8rem' }}>
              Managing Director: Krishna Khanal (Contact: 9867155395)
            </div>
            <p style={{ fontSize: '0.88rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1.4rem' }}>
              Providing authentic Palpali Bhoj, Newari Samay Baji feasts, Royal Indian Banquets, marquee tents, and Palpali floral mandap decor for your wedding ceremony.
            </p>
            <button className="btn btn-primary" onClick={() => navigate('/catering')}>
              Explore Sabitri Catering & Mandap Decor →
            </button>
          </div>

          <div style={{ background: '#FAF6ED', padding: '1.8rem', borderRadius: '16px', border: '1px solid #E8DFD1' }}>
            <h4 style={{ fontWeight: 800, color: '#1C1014', marginBottom: '0.8rem' }}>📍 Official Business Location</h4>
            <div style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.8 }}>
              🏢 <strong>Main Office:</strong> Yogikuti, Butwal, Nepal<br />
              💍 <strong>Matrimonial Director:</strong> Laxmikant Timilsina (9857074103)<br />
              🍽️ <strong>Catering & Decor Manager:</strong> Krishna Khanal (9867155395)<br />
              💻 <strong>Technical Support:</strong> Prakash Sharma Timilsina (<a href="https://pourkas.org" target="_blank" rel="noopener noreferrer" style={{ color: '#9E1B32', fontWeight: 700, textDecoration: 'underline' }}>pourkas.org</a>)
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
